<template>
  <v-expansion-panels v-if="Array.isArray(conditions) || Array.isArray(enableWhen)" v-model="open" class="pt-3">
    <v-expansion-panel>
      <v-expansion-panel-header>
        <slot name="title">
          <AdCardTitle inline style="padding: 0 !important">
            {{ title || $t('conditions') }}
          </AdCardTitle>
        </slot>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-list v-if="Array.isArray(conditions)" class="pa-0 mb-2" :class="{'mb-2': Array.isArray(enableWhen)}">
          <v-list-item v-for="(cond) in conditionWithId(conditions)" :key="cond.uuid" class="pa-0">
            <v-list-item-content class="pa-0">
              <TextualCondition :item="cond" :conceptName="getQuestionName(cond.question)"/>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-list v-if="Array.isArray(enableWhen)" class="pa-0">
          <v-list-item v-for="structuralCondition in conditionWithId(enableWhen)" :key="structuralCondition.uuid" class="pa-0">
            <v-list-item-content class="pa-0">
              <StructuralCondition :item="structuralCondition" :conceptName="getQuestionName(structuralCondition.question)"/>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import StructuralCondition from '@/components/Utilities/StructuralCondition'
import TextualCondition from '@/components/Utilities/TextualCondition'

export default {
  components: {
    StructuralCondition,
    TextualCondition
  },
  props: {
    conditions: { // Textual conditions
      type: Array,
      default: null
    },
    enableWhen: { // Structural conditions
      type: Array,
      default: null
    },
    getQuestionName: { // Function that returns a string. Recieves 'id' as argument.
      type: Function,
      default: id => id
    },
    title: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      open: 0
    }
  },
  methods: {
    conditionWithId (cond) {
      if (!Array.isArray(cond)) return []
      return cond.map(item => ({ ...item, uuid: this.getUuid() }))
    }
  }
}
</script>
